import React, { useEffect, useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Select, Spin, Image, Form, Input, message, Button, Space, Card } from 'antd';
import "../../../node_modules/bootstrap/dist/css/bootstrap.min.css";
import { makeRequest } from '../../services/api';

export default function AdminDashboard() {
    const { Option } = Select;

    const [form] = Form.useForm();
    const [vehicles, setVehicles] = useState([]);

    const onFinish = async (evt) => {
        if (evt.vehicleId.length == 0) {
            return message.error('Select a vehicle', 3);
        };

        if (evt.vehicleName.length == 0) {
            return message.error('Please enter a name', 3);
        };

        updateVName({ _id: evt.vehicleId, name: evt.vehicleName })
    };

    const clear = () => {
        onReset();
    }

    useEffect(() => {
        getVehicleList();
    }, []);

    const updateVName = async (obj) => {
        try {
            let url = process.env.REACT_APP_BACKEND_URL + '/locations/vehicles/update';

            const response = await makeRequest('post', url, obj);
            if(response) {
                clear();
                getVehicleList();
                return message.success(response.message, 3);
            } else {
                return message.error('Error occured while updating the vehicle name', 3);
            }
            
        } catch (e) {
            console.log(e, 'err');
            return message.error(e.message, 3);
        }
    }

    const onReset = () => {
        form.resetFields();
    };

    const onFinishFailed = () => {
        message.error('Oops an error occured!', 3);
    };

    const getVehicleList = async () => {
        try {
            let url = process.env.REACT_APP_BACKEND_URL + '/locations/vehicles/name';

            const { data } = await makeRequest('get', url);
            setVehicles(data)
            return data;
        } catch (e) {
            console.log(e, 'err');
            return message.error(e.message, 3);
        }
    };

    return (

        <div className="row justify-content-center my-3">
            <div className="col-md-11">
                <div className="site-card-border-less-wrapper">
                    <Card title="Update Vehicle Name" bordered={false} style={{ width: "100%" }}>
                        <Form
                            form={form}
                            layout="vertical"
                            onFinish={onFinish}
                            onFinishFailed={onFinishFailed}
                            autoComplete="off"
                        >
                            <Form.Item
                                name="vehicleId"
                                label="Select a vehicle:"
                                rules={[{ required: true }]}>
                                <Select
                                    showSearch
                                    placeholder="ex:- shuttle 17B (789066)"
                                    onChange={console.log}
                                    allowClear
                                    optionFilterProp="children"
                                    filterOption={(input, option) =>
                                        option.props.children
                                            .toLowerCase()
                                            .indexOf(input.toLowerCase()) >= 0 ||
                                        option.props.value
                                            .toLowerCase()
                                            .indexOf(input.toLowerCase()) >= 0
                                    }
                                >
                                    {vehicles.map((option, index) => (
                                        <Option value={option["_id"]}>{option["name"]}</Option>
                                    ))}
                                </Select>
                            </Form.Item>

                            <Form.Item
                                name="vehicleName"
                                label="* Vehicle Name:"
                                rules={[{ required: true }, { type: "string", min: 1 }]}
                            >
                                <Input placeholder="12B, 1s2C" maxLength={100} />
                            </Form.Item>

                            <Form.Item>
                                <Space>
                                    <Button type="primary" htmlType="submit">
                                        Submit
                                    </Button>
                                </Space>
                            </Form.Item>
                        </Form>
                    </Card>
                </div>
            </div>
        </div>

    );
}